import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api";
import { Briefcase, Handshake } from "lucide-react";
import { CareersShell, JobCard } from "@/components/jobs/CareersShell";

const FILTERS = [["all", "Toutes les offres"], ["emploi", "Emplois"], ["business_partner", "Business Partners"]];

export default function Carrieres() {
  const [data, setData] = useState({ offers: [], counts: {} });
  const [kind, setKind] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/jobs").then((r) => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const offers = data.offers.filter((o) => kind === "all" || o.kind === kind);

  return (
    <CareersShell>
      <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-10 items-end mb-12">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-[#868E96] font-semibold mb-3">// PAG JOB</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter" data-testid="careers-title">Rejoignez PAG — en équipe ou en partenaire.</h1>
          <p className="mt-5 text-base text-[#495057] max-w-xl">
            Nous recrutons des talents pour construire la plateforme RH et paie des commerçants, campings et petites entreprises —
            et des <b>Business Partners indépendants</b> qui la font connaître, rémunérés à la commission.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <div className="bg-[#002FA7] text-white p-5" data-testid="careers-count-emploi">
            <Briefcase className="h-5 w-5 mb-3" />
            <div className="font-display font-black text-3xl">{data.counts?.emploi ?? 0}</div>
            <div className="text-[10px] uppercase tracking-[0.25em] opacity-80">offre(s) d'emploi</div>
          </div>
          <div className="bg-[#FFD700] text-[#0A0A0A] p-5" data-testid="careers-count-bp">
            <Handshake className="h-5 w-5 mb-3" />
            <div className="font-display font-black text-3xl">{data.counts?.business_partner ?? 0}</div>
            <div className="text-[10px] uppercase tracking-[0.25em] opacity-80">mandat(s) Business Partner</div>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-1.5 mb-6">
        {FILTERS.map(([k, l]) => (
          <button key={k} type="button" onClick={() => setKind(k)} data-testid={`careers-filter-${k}`}
                  className={`text-[11px] uppercase tracking-wider font-bold px-3 py-2 border transition ${kind === k ? "bg-[#0A0A0A] text-white border-[#0A0A0A]" : "bg-white border-[#DEE2E6] hover:border-[#0A0A0A]"}`}>{l}</button>
        ))}
      </div>

      {loading ? (
        <div className="text-sm text-[#868E96]">Chargement des offres…</div>
      ) : offers.length === 0 ? (
        <div className="bg-white border border-[#DEE2E6] p-10 text-center" data-testid="careers-empty">
          <div className="font-display font-black text-xl">Aucune offre ouverte pour le moment.</div>
          <p className="text-sm text-[#495057] mt-2">Envoyez-nous une candidature spontanée à <a className="underline" href="mailto:contact@parcavenue.eu">contact@parcavenue.eu</a>.</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="careers-list">
          {offers.map((o) => <JobCard key={o.id} offer={o} />)}
        </div>
      )}

      <div className="mt-12 bg-[#0A0A0A] text-white p-8 grid md:grid-cols-[1fr_auto] gap-6 items-center" data-testid="careers-spontaneous-block">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#FFD700] font-bold mb-2">Aucune offre ne vous correspond ?</div>
          <div className="font-display font-black text-2xl tracking-tight">Envoyez une candidature spontanée.</div>
          <p className="text-sm text-white/70 mt-2 max-w-xl">Emploi au sein de l'équipe PAG ou mandat Business Partner dans votre région : même formulaire, même attention, réponse sous 10 jours ouvrés.</p>
        </div>
        <Link to="/carrieres/spontanee" className="inline-flex items-center justify-center h-12 px-6 bg-[#FFD700] text-[#0A0A0A] font-bold text-sm hover:bg-white transition-colors" data-testid="careers-spontaneous-link">Candidature spontanée</Link>
      </div>

      <div className="mt-14 border-t border-[#DEE2E6] pt-8 text-xs text-[#868E96]">
        Les candidatures sont traitées par l'équipe PAG uniquement. Vos données ne sont jamais transmises à des tiers — voir notre <Link to="/legal/confidentialite" className="underline">politique de confidentialité</Link>.
      </div>
    </CareersShell>
  );
}
